import React from "react";

const Intro = () => {
  return (
    <div className="Intro w-screen">
      <h3 className="text-center mt-10 text-2xl text-slate-500">
        React & Node
      </h3>
      <div className="i-background w-full bg-blue-200 min-h-[60vh] mt-[5rem] relative">
        <h1 className="text-center text-8xl font-serif font-extralight absolute -top-[3rem] left-[50%] -translate-x-[50%]">
          BLOG
        </h1>
      </div>
    </div>
  );
};

export default Intro;
